const TOKEN_KEY = 'token';

let identify = sessionStorage.getItem(TOKEN_KEY) || '';

export function getToken() {
  return identify;
}

export function setToken(token) {
  identify = token || '';
  if (identify) {
    sessionStorage.setItem(TOKEN_KEY, identify);
  } else {
    sessionStorage.removeItem(TOKEN_KEY);
  }
  return identify;
}

export function clearToken() {
  setToken('');
}



// WEBPACK FOOTER //
// ./src/utils/authToken.js